<template>
  <div class="page" :style="{ height: '100%' }">
    <van-tabs class="collect-tabs" v-model="active">
      <van-tab title="全部" :key="0"> </van-tab>
      <van-tab
        v-for="(item, index) in statusOptions"
        :title="item.name"
        :key="index + 1"
      >
      </van-tab>
    </van-tabs>
    <div
      class="order-list"
      id="pageOrder"
    >
      <van-empty v-if="noData" description="暂无订单～" />
      <div v-else class="item" v-for="(item, index) in dataList" :key="index">
        <div class="status">
          <span :class="'status' + item.status">{{
            getNameFormSstatus(item)
          }}</span>
        </div>
        <div class="title-box">
          <div class="title">{{ item.title }}</div>
          <div class="more">
            <img @click="item.isShowBtns = !item.isShowBtns" src="./assets/images/more.png" alt="" srcset="" />
            <div class="more-btns" v-show="item.isShowBtns">
              <div
                class="btn"
                @click="refundOrder(item)"
                v-if="publicData.accountBasic && publicData.accountBasic.isCanRefund && item.status == 1">
                退保
              </div>
              <div v-if="item.status == 0">
                  <div class="btn" @click="delOrder(item)" >
                删除
              </div>
              <!-- <div class="btn" @click="editOrder(item)" >
                编辑
              </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="info">被保人：{{ item.tipName }}</div>
        <div class="info">
          保障期限：{{ moment(item.startDate).format("YYYY-MM-DD") }}-{{
            moment(item.endDate).format("YYYY-MM-DD")
          }}
        </div>
        <div class="info">订单号：{{ item.tradeNo }}</div>
        <div class="btns">
          <div class="price">
            共计：<span>￥{{ item.payPrice }}</span>
          </div>
          <div class="btn">
            <div class="btn-el down" @click="exportFile(item)" v-if="item.status == 1 && item.insuranceResult === '投保成功'">下载保单</div>
            <!-- <div class="btn-el buy">继续购买</div> -->
            <div class="btn-el buy" v-if="(item.status == 0)" @click="payOrder(item)">立即支付</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog, Tab, Tabs, Empty, Toast } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
var wx = require("weixin-js-sdk");

export default {
  name: "Collect",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Empty.name]: Empty,
    [Toast.name]: Toast,
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
      openId: "",
      isLoading: false,
      statusOptions: [
        {
          id: 0,
          name: "待支付",
        },
        {
          id: 1,
          name: "已支付",
        },
        {
          id: 2,
          name: "已退单",
        },
        {
          id: 5,
          name: "暂存单",
        },
        {
          id: 10,
          name: "正在出单",
        },
        {
          id: 11,
          name: "已删除",
        },
      ],
      active: 0,
      tagList: [],
      dataList: [],
      params: {
        queryKey: "",
        pageNumber: 1,
        pageSize: 10,
      },
      noData: false,
    };
  },
  watch: {
    active: function (val) {
      if (val == 0) {
        this.params.status = "";
      } else {
        this.params.status = this.statusOptions[val - 1].id;
      }
      this.params.pageNumber = 1;
      this.$nextTick(()=>{
          this.loadList();
      })
    },
  },
  async mounted() {
    // this.getTags();
    // this.getCollectList();
    // 跳转微信
    wechatService.auth(
      0,
      ({ openid, unionid }) => {
        if (!!openid && !!unionid) {
          console.log("openId", openid);
          this.unionId = unionid;
          this.openId = openid;
        }
      },
      false
    );
    await this.loadList();
    this.$nextTick(() => {
      let page = document.getElementById("pageOrder"); //绑定在当前组件上
      page.addEventListener("scroll", this.scroll, true);
    });
  },
  beforeDestroy: function () {},
  methods: {
    async loadList() {
      this.isLoading = true;
      const end = new Date(new Date().toLocaleDateString()).getTime() + 86400000 - 1000;
      const start = new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 90;
      this.params.accountId = this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId;
      this.params.subAccountId = this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id;
      this.params.companyId = this.publicData.companyId;
      this.params.startTime = start;
      this.params.endTime = end;
      let res = await this.$http.post("/api/bill/getList", this.params);
      this.noData = false;
      if (this.params.pageNumber == 1) {
        //
        this.dataList = [];
        if (!res.list.length) {
          this.noData = true;
        }
      }
      res.list.forEach((el) => {
        el.isShowBtns = false
        el.insurePeople = JSON.parse(el.insurePeople);
        if (!!el.togetherInfos) {
          el.togetherInfos = JSON.parse(el.togetherInfos);
        }
        let nameArr = [];
        if (el.togetherInfos.length > 3) {
          el.togetherInfos.forEach((eoEl, index) => {
            if (index <= 3) {
              nameArr.push(eoEl.n);
            }
          });
        } else {
          el.togetherInfos.forEach((eoEl) => {
            nameArr.push(eoEl.n);
          });
        }

        if (el.togetherInfos.length > 3) {
          el.tipName = nameArr.join(",") + "等" + el.num + "人";
        } else {
          el.tipName = nameArr.join(",");
        }
      });
      for (let i = 0; i < res.list.length; i++) {
        //计算出单情况
        let el = res.list[i];
        if (el.status == 1 && el.insuranceResult != "投保成功") {
          el.danStatus = 1;
          continue;
        }
        if (el.status == 1) {
          let date = new Date().getTime();
          let start = this.moment(el.startDate).valueOf();
          let end = this.moment(el.endDate).valueOf();
          if (date < end && date > start) {
            el.danStatus = 2;
            continue;
          }
        }

        if (el.status == 0) {
          el.danStatus = 6;
          continue;
        }

        if (el.status == -1) {
          el.danStatus = 5;
          continue;
        }
        if (el.status == 2) {
          el.danStatus = 7;
          continue;
        }
        if (el.status == 5) {
          el.danStatus = 8;
          continue;
        }

        if (el.status == 6) {
          el.danStatus = 4;
          continue;
        }

        if (el.status == 10) {
          el.danStatus = 9;
          continue;
        }
        if (el.status == 11) {
          el.danStatus = 10;
          continue;
        }

        if (el.status == 1 && el.insuranceResult == "投保成功") {
          console.log("好处呢故宫");
          el.danStatus = 3;
          continue;
        }
      }
      this.dataList = [...this.dataList, ...res.list];
      this.isLoading = false;
    },
    getNameFormSstatus(row) {
      let name = "";
      this.statusOptions.forEach((el) => {
        if (el.id == row.status) {
          name = el.name;
          if (el.id == 1) {
            if (row.insuranceResult == "投保成功") {
              name = "已出保";
            } else {
              name = "出保失败";
            }
          }
        }
      });
      return name;
    },
    // 下载保单
    exportFile(item) {
      Toast("请在PC端登录下载保单！");
      // return;
      // let url = "/api/accountBill/print";
      // Toast.loading({
      //   message: "下载中...",
      //   forbidClick: true,
      // });
      util.exportFile(
        url,
        {
          billId: item.id,
        },
        this,
        () => {
          console.log("下好了");
          Toast.clear();
        },
        () => {
          Toast.clear();
        }
      );
    },
    // 退保
    async refundOrder(item) {
      Dialog.confirm({
        title: "提示",
        message: `确定要退保订单号为${item.tradeNo}的订单吗？`,
      })
        .then(async () => {
          let res = await this.$http.post("/api/refundBillOrder", {
            billId: item.id,
            type: 2,
          });
          if (!res.code) {
            this.$toast("退保成功！");
            this.params.pageNumber = 1;
            this.loadList();
          }else{
              this.$toast(res.msg)
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    // 删除
    async delOrder(item) {
      Dialog.confirm({
        title: "提示",
        message: `确定要删除订单号为${item.tradeNo}的订单吗？`,
      })
        .then(async () => {
          let res = await this.$http.post("/api/bill/deleteForSale", {
            billId: item.id,
          });
          if (!res.code) {
            this.$toast("删除成功！");
            this.params.pageNumber = 1;
            this.loadList();
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    // 修改
    async editOrder(item,type){
      
      // Dialog.confirm({
      //   title: "提示",
      //   message: `确定要修改订单号为${item.tradeNo}的订单吗？`,
      // })
      this.$router.push({
        name:'editOrder',
        query:{
          // abid:item.accountBillId,
          // aid:item.id,
          id:item.productId,
          // type:type
        }
      })
    },
    async payOrder(item) {
      // console.log("item",item)
      let accountBillId = item.accountBillId;
      console.log("accountBillId", accountBillId);
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "支付中...",
      });
      if (item.accountBillId == 0) {
        let res1 = await this.$http.post("/api/accountBill/buildBill", {
          accountId:this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
          subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
          together: item.together,
          companyId: this.publicData.companyId,
          payType: 1,
          relationBillIds: JSON.stringify([item.id]),
          opName: !!this.publicData.name ? this.publicData.name : "",
          summary: item.title,
          remark: item.remark,
        });
        if (res1.code == 0) {
          accountBillId = res1.t.id;
        }
      }
      console.log("1111111234567890")
      if (this.$page.isInMiniprogram) {
        //小程序
        let aliParams = {
          accountBillId: accountBillId,
          paytype: "W06",
          acct: this.openId,
        };
        let aliRes = await this.$http.post("/api/order.union.create",aliParams);
        console.log("aliRes",aliRes)
        Toast.clear();
        if (!aliRes.code) {
          console.log("aliRes", aliRes.t.payinfo);
          let payinfo = JSON.parse(aliRes.t.payinfo);
          wx.miniProgram.navigateTo({
            url:"/pages/pay/pay?iid=0" + "&payInfo=" + encodeURIComponent(JSON.stringify(payinfo)) + "&from=2",
            success: function () {
            //   window.history.go(-1);
            },
          });
        }
      } else {
          Toast.clear();
      }
    },
    scroll() {
      console.log(666);
      if (this.isLoading) return;
      let page = document.getElementById("pageOrder");
      if (page.scrollTop + window.innerHeight > page.scrollHeight - 1) {
        this.params.pageNumber++;
        this.loadList();
      }
    },

    async delCollect(item) {
      // collect/delete
      Dialog.confirm({
        title: "提示",
        message: `确定要取消收藏${item.title}吗？`,
      })
        .then(async () => {
          // on confirm
          let res = await this.$http.post("/api/collect/delete", {
            accountId: this.publicData.id,
            id: item.id,
            insuranceProductionId: item.id,
          });
          if (!res.code) {
            this.$toast("取消收藏成功！");
            this.getCollectList();
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    gotoDetail(item) {
      this.$router.push({
        name: "Detail",
        query: {
          id: item.uniqId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  font-size: 0.14rem;
  display: flex;
  flex-direction: column;
  .order-list {
    overflow-y: scroll;
    .item {
      padding: 0.21rem 0.15rem;
      box-sizing: border-box;
      border-bottom: 1px solid #ebeef0;
      .status {
        width: fit-content;
        background: rgba(0, 169, 113, 0.1);
        border: 0px solid #00a971;
        padding: 2px;
        box-sizing: border-box;
        span {
          font-size: 0.12rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #2dd97a;
          line-height: 1;
          &.status0 {
            color: #999;
          }
          &.status1 {
            color: #2dd97a;
          }
          &.status2 {
            color: red;
          }
          &.status5 {
            color: blueviolet;
          }
          &.status10 {
            color: steelblue;
          }
          &.status11 {
            color: burlywood;
          }
        }
      }
      .title-box {
        margin: 0.1rem 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          font-size: 0.16rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }
        .more {
          width: 0.22rem;
          flex-shrink: 0;
          position: relative;
          .more-btns {
            position: absolute;
            right: 0rem;
            top: 0.1rem;
            background: rgba(0, 169, 113, 0.08);
            width: 0.65rem;
            border-radius: 0.04rem;
            .btn {
              padding: 0.1rem 0.19rem;
              font-size: 0.12rem;
              font-family: PingFang;
              font-weight: 400;
              color: #333333;
            }
          }
          img {
            width: 100%;
          }
        }
      }
      .info {
        height: 0.12rem;
        font-size: 0.12rem;
        font-family: PingFang;
        font-weight: 500;
        color: #666666;
        margin: 0.05rem 0;
      }
      .btns {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.15rem;
        .price {
          color: rgba(12, 16, 20, 1);
          font-size: 0.14rem;
          font-weight: bold;
          span {
            font-size: 0.14rem;
            font-family: PingFang;
            font-weight: bold;
            color: rgba(255, 114, 35, 1);
          }
        }
        .btn {
          display: flex;
          .btn-el {
            background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
            border-radius: 0rem;
            font-size: 0.12rem;
            font-family: PingFang;
            font-weight: bold;
            color: #ffffff;
            padding: 0.07rem 0.14rem;
            margin-left: 0.1rem;
            border-radius: 0.02rem;
            border: 1px solid #2dd97a;
            &.down {
              background: #fff;
              color: #2dd97a;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.page {
  .collect-tabs {
    background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
    .van-tabs__nav {
      background: rgba(0, 0, 0, 0);
      .van-tab {
        font-size: 0.14rem;
        font-family: PingFang;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.75);
        // line-height: 0.2rem;
        .van-tab__text {
          font-size: 0.14rem;
        }
        &.van-tab--active {
          font-size: 0.17rem;
          font-family: PingFang;
          font-weight: bold;
          color: #ffffff;
          .van-tab__text {
            font-size: 0.17rem;
          }
        }
      }
      .van-tabs__line {
        background-color: #fff;
        height: 0.03rem;
        width: 0.18rem;
        bottom: 21px;
      }
    }
  }
}
</style>